module.exports = __webpack_public_path__ + "static/9heartwarminggames0-1233bcaf3161b90ce720e57148033d81.webp";